import type { ComputedRef, InjectionKey, Ref } from 'vue';
import type { IFlatFolderItem } from '@/types/services/folder.service';
import type { IAttributesResponse, IDetailsResponse } from '@/types/services/user.service';
import type { IAvatarGetResponse } from '@/types/services/avatar.service';
import type { IContactListData } from '@/types/services/contact.service';
import type { QueryObserverResult } from '@tanstack/vue-query';

export type IMailboxSharedActionDialogMutationFn = () => void;

export const MAILBOX_SHARED_ACTIONS_DIALOG_KEY = Symbol(
  'MAILBOX_SHARED_ACTIONS_DIALOG_KEY'
) as InjectionKey<{
  setDialogText: (
    label: string,
    text: string,
    callback: IMailboxSharedActionDialogMutationFn
  ) => void;
}>;

export const MAILBOX_SHARED_FOLDERS_INJECT_KEY = Symbol(
  'MAILBOX_SHARED_FOLDERS_INJECT_KEY'
) as InjectionKey<{
  flatFolders: Ref<undefined | IFlatFolderItem[]>;
  isFlatFoldersLoading: Ref<boolean>;
}>;

export const MAILBOX_SHARED_DETAILS_INJECT_KEY = Symbol(
  'MAILBOX_SHARED_DETAILS_INJECT_KEY'
) as InjectionKey<{
  userDetails: Ref<undefined | IDetailsResponse>;
  userDetailsSuspense: () => Promise<QueryObserverResult<IDetailsResponse, Error>>;
  userAttributes: Ref<undefined | IAttributesResponse>;
  userAttributesSuspense: () => Promise<QueryObserverResult<IAttributesResponse, Error>>;
}>;

export const MAILBOX_SHARED_AVATAR_INJECT_KEY = Symbol(
  'MAILBOX_SHARED_AVATAR_INJECT_KEY'
) as InjectionKey<Ref<null | undefined | IAvatarGetResponse>>;

export const MAILBOX_SHARED_CONTACT_INJECT_KEY = Symbol(
  'MAILBOX_SHARED_CONTACT_INJECT_KEY'
) as InjectionKey<{
  contactsData: Ref<undefined | IContactListData>;
  emailMappedContacts: ComputedRef<Record<string, IContactListData[0] | undefined>>;
}>;
